import styled from '@emotion/styled'

export const StyleWrapper = styled.div`
  padding: 16px;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05); /* Removed static boxShadow */
  background-color: ${({ theme }: any) => theme.colors.white};
`
